module.exports = __webpack_public_path__ + "img/image_8.2bb5f993.jpg";